/**
 * Get The Difference between both dates
 * @param {number} date1 - Oldest date in epoch date format in milliseconds
 * @param {number} date2 - Newest date in epoch date format in milliseconds
 */
export default (date1, date2 = Date.now(), negDate1 = Date.now(), negDate2 = Date.now()) => {
    const SECOND = 1000;
    const MINUTE = SECOND * 60;
    const HOUR = MINUTE * 60;

    try {
        const diff = Math.round(date2 - date1) - Math.round(negDate2 - negDate1);
        const seconds = Math.floor(diff/SECOND) % 60;
        const minutes = Math.floor(diff/MINUTE) % 60;
        const hours = Math.floor(diff/HOUR);

        return `${hours !== 0 ? hours + 'h:' : ''}${minutes !== 0 ? minutes + 'm:' : ''}${seconds}s`;
    } catch (err) {
        console.error("date1, or date2 are not date objects");
    }
}